import { useEffect as l } from "react";
let t = 0;
const o = () => {
  const { documentElement: e } = document;
  t > 0 ? e.style.overflow = "hidden" : e.style.overflow = "";
}, f = (e) => {
  l(() => (e && (t++, o()), () => {
    e && (t--, o());
  }), [e]);
};
export {
  f as useScrollLock
};
